import { httpGet, httpPost, httpPatchMerge, httpDelete } from './http'
import type { ITsdContact } from '~/types/contact/models'
import type { TEntityId } from '~/types/models'
import { Contact } from '~/cynqueModules/dataObjects/Contact'

const apiEntityPath = '/api/tsdcontacts'

export async function getTsdContacts({ apiPath = apiEntityPath } = {}) {
  const callingMn = getTsdContacts.name
  return httpGet<ITsdContact[]>({ callingMn, apiPath })
}

export async function getTsdContactsPreProcessed({
  apiPath = apiEntityPath,
} = {}) {
  const callingMn = getTsdContacts.name
  const rawTsdContacts = await httpGet<ITsdContact[]>({ callingMn, apiPath })
  return rawTsdContacts.map((rawTsdContact) => Contact(rawTsdContact))
}

export async function createTsdContact(entity: ITsdContact) {
  const callingMn = createTsdContact.name
  const apiPath = apiEntityPath
  return httpPost<ITsdContact>({ callingMn, apiPath, entity })
}

export async function updateTsdContact(
  entityData: Partial<ITsdContact>,
  id: TEntityId
) {
  const callingMn = updateTsdContact.name
  const apiPath = `${apiEntityPath}/${id}`
  type TPartialITsdContact = Partial<ITsdContact>
  return httpPatchMerge<TPartialITsdContact>({
    callingMn,
    apiPath,
    entityData,
  })
}

export async function deleteTsdContact(entityData: ITsdContact) {
  const callingMn = deleteTsdContact.name
  const apiPath = apiEntityPath
  return httpDelete<ITsdContact>({
    callingMn,
    apiPath,
    entityData,
  })
}
